import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { CheckoutInfo } from '22ndtech-common-lib';
import { ConfigService } from '../config/config.service';
import { CartService } from '../cart/cart.service';
import { CartItem } from '22ndtech-common-lib';
import { ShippingAddress } from '22ndtech-common-lib';
import { LoggingService } from '../loging/logging.service';

declare var Stripe: any;
export class CheckoutService {
    checkoutInfo: CheckoutInfo = new CheckoutInfo();
private baseUrl = '';
private creditCardTokenSubject: Subject<any>;
private configured = false;
private config: any;
/**
 * @param {?} http
 * @param {?} configService
 * @param {?} cartService
 * @param {?} loggingService
 */
constructor(
private http: Http,
private configService: ConfigService,
private cartService: CartService,
private loggingService: LoggingService
    ) {
        this.cartService.observableCartItems.subscribe(
            (newCartItems) => this.updateTotals()
        )

        this.creditCardTokenSubject = new Subject<any>();
        this.loggingService.log('this.configService = ' + JSON.stringify(this.configService));

        this.updateShippingCost(5.95);

        this.configService.getConfig((configuration: any) => {
            this.config = configuration;
            this.baseUrl = this.config.baseUrl;
            this.configured = true;

            Stripe.setPublishableKey(this.config.stripe_publishable_key);
        });
    }
/**
 * @param {?} checkoutInfo
 * @return {?}
 */
getCreditCardToken(checkoutInfo: CheckoutInfo): Observable<any> {
        this.checkoutInfo = checkoutInfo;
        if (this.creditCardTokenSubject) {
            this.creditCardTokenSubject = new Subject<any>();
        }

        let /** @type {?} */ message = '';
        message += 'checkout.service.ts:CheckoutService.checkout()\n\n';
        message += '  Stripe = ' + Stripe + '\n\n';
        message += 'cartItems = ' + JSON.stringify(this.checkoutInfo) + '\n\n';


        Stripe.card.createToken({
            number: checkoutInfo.ccnumber,
            cvc: checkoutInfo.ccv2,
            exp_month: checkoutInfo.ccexpmonth,
            exp_year: checkoutInfo.ccexpyear
        }, (status: any, response: any) => {
            this.loggingService.log('tokenCreated :\n\tstatus = ' + status + '\n\tresponse = ' + JSON.stringify(response));

            // const url = this.baseUrl + "checkout/";
            // return this.http.put(
            //    url,
            //    {})
            //    .map(res => res.json());
            // if (status === 200) {
            //    this.creditCardTokenSubject.next(response);
            // } else {
            //     throw (response);
            // }

            // replaced the commented out code above with the line below to pass errors through
            // to the checkout.component.ts so they could be displayed on the page
            this.creditCardTokenSubject.next(response);
        });

        return this.creditCardTokenSubject.asObservable();
    }
/**
 * @return {?}
 */
getCreditCardToken2(): void {
        this.getCreditCardToken(this.checkoutInfo).subscribe(
            (next) => {
                this.checkoutInfo.cardToken = next.id;
                this.createCharge(this.checkoutInfo).subscribe(
                    (nextCheckoutInfo) => {
                        this.loggingService.log('checkout.component.ts:getCreditCardToken nextCheckoutInfo = ' + nextCheckoutInfo);
                    },
                    (err) => {
                        this.loggingService.log('create charge err = ' + err);
                    },
                    () => {
                        this.loggingService.log('create charge completed');
                        this.cartService.clear();
                        this.checkoutInfo.cardToken = null;
                        window.location.href = '/';
                    }
                );
            },
            (err) => {
                this.loggingService.log('err = ' + JSON.stringify(err));
            },
            () => {
                this.loggingService.log('completing');
            }
        );
    }
/**
 * @param {?} checkoutInfo
 * @return {?}
 */
createCharge(checkoutInfo: CheckoutInfo): Observable<any> {
        checkoutInfo.cartItems = this.cartService.cartItems;
        this.checkoutInfo = checkoutInfo;

        this.loggingService.log('createCharge this.checkoutInfo = ' + JSON.stringify(this.checkoutInfo));
        let /** @type {?} */ url = this.baseUrl + '/checkout/charges';
        return this.http.post(url, { checkoutInfo: checkoutInfo }).map(
            (response) => {
                this.loggingService.log('createCharge response =');
                this.loggingService.log(response);
                return response.json;
            }
        );
    }
/**
 * @return {?}
 */
getGrandTotal(): number {
        return this.cartService.getTotalBeforeTax();
    }
/**
 * @return {?}
 */
updateTotals() {

        this.checkoutInfo.total_before_tax = this.cartService.getTotalBeforeTax();

        this.checkoutInfo.sales_tax = Math.round(this.cartService.getTotalBeforeTax() * this.checkoutInfo.sales_tax_rate) / 100;

        this.checkoutInfo.total_after_tax = Math.round((this.checkoutInfo.total_before_tax + this.checkoutInfo.sales_tax) * 100) / 100;

        this.checkoutInfo.grand_total = Math.round((this.checkoutInfo.total_after_tax + this.checkoutInfo.shipping_cost) * 100) / 100;
    }
/**
 * @param {?} newShippingCost
 * @return {?}
 */
updateShippingCost(newShippingCost: number) {
        this.checkoutInfo.shipping_cost = newShippingCost;
    }
/**
 * @return {?}
 */
setShippingAddress(): void {
        if (!this.checkoutInfo.shipping_address) {
            this.checkoutInfo.shipping_address = new ShippingAddress();
        }

        if (!this.checkoutInfo.shipping_address.full_name) {
            this.checkoutInfo.shipping_address.full_name = this.checkoutInfo.nameoncard;
        }

        if (!this.checkoutInfo.shipping_address.address_line1) {
            this.checkoutInfo.shipping_address.address_line1 = this.checkoutInfo.address_line1;
        }

        if (!this.checkoutInfo.shipping_address.address_line2) {
            this.checkoutInfo.shipping_address.address_line2 = this.checkoutInfo.address_line2;
        }

        if (!this.checkoutInfo.shipping_address.city) {
            this.checkoutInfo.shipping_address.city = this.checkoutInfo.address_city;
        }

        if (!this.checkoutInfo.shipping_address.state) {
            this.checkoutInfo.shipping_address.state = this.checkoutInfo.address_state;
        }

        if (!this.checkoutInfo.shipping_address.zip) {
            this.checkoutInfo.shipping_address.zip = this.checkoutInfo.address_zip;
        }

        if (!this.checkoutInfo.shipping_address.country) {
            this.checkoutInfo.shipping_address.country = this.checkoutInfo.address_country;
        }

        if (!this.checkoutInfo.shipping_address.phone_number) {
            this.checkoutInfo.shipping_address.phone_number = this.checkoutInfo.address_phone;
        }

    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: ConfigService, },
{type: CartService, },
{type: LoggingService, },
];
}

function CheckoutService_tsickle_Closure_declarations() {
/** @type {?} */
CheckoutService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CheckoutService.ctorParameters;
/** @type {?} */
CheckoutService.prototype.checkoutInfo;
/** @type {?} */
CheckoutService.prototype.baseUrl;
/** @type {?} */
CheckoutService.prototype.creditCardTokenSubject;
/** @type {?} */
CheckoutService.prototype.configured;
/** @type {?} */
CheckoutService.prototype.config;
/** @type {?} */
CheckoutService.prototype.http;
/** @type {?} */
CheckoutService.prototype.configService;
/** @type {?} */
CheckoutService.prototype.cartService;
/** @type {?} */
CheckoutService.prototype.loggingService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
